import { render, staticRenderFns } from "./chatWedget-hx.vue?vue&type=template&id=295573a1&"
import script from "./chatWedget-hx.vue?vue&type=script&lang=js&"
export * from "./chatWedget-hx.vue?vue&type=script&lang=js&"
import style0 from "./chatWedget-hx.vue?vue&type=style&index=0&id=295573a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports